<template>
    <div>
        <!-- Navigation -->
        <div class="mb-4 d-flex justify-content-between">
            <div>
                <a :href="previousUrl" class="ix-absence-table-navigation-button">
                    <i class="far fa-angle-left"></i>
                </a>
                <a :href="nextUrl" class="ix-absence-table-navigation-button">
                    <i class="far fa-angle-right"></i>
                </a>

                <form method="GET" class="d-inline-block ml-4" id="dateForm">
                    <div class="ix-datepicker-wrapper">
                        <input type="text" class="form-control datepicker" id="date" v-model="date.date" name="date">
                    </div>
                </form>

                <div class="d-inline-block ml-4">
                    <select v-model="selectedStation" class="form-control">
                        <option :value="null">Afficher l'ensemble des postes de travail</option>
                        <option :value="station" v-for="(station, index) in stations" v-bind:key="index">{{ station.name }}</option>
                    </select>
                </div>
            </div>
        </div>

        <div class="ix-comments-loader" v-if="loading">
            <i class="far fa-circle-notch fa-spin"></i> Chargement du planning
        </div>

        <div class="ix-kanban justify-content-center" id="board">
            <div class="ix-kanban-column ix-kanban-column-large-display" v-bind:class="{'ix-kanban-column-accent-blue': date.is_today}">
                <div class="ix-kanban-column-header">
                    <span class="ix-text-capitalize">{{ this.date.label }}</span>
                    <span class="d-block ix-text-small ix-text-secondary">{{ this.date.date }}</span>
                </div>

                <div class="ix-kanban-column-content">
                    <div class="ix-kanban-card" v-for="(schedule, sIndex) in filteredSchedules" :key="sIndex" v-bind:class="schedule.lot.state_color">
                        <div class="ix-kanban-card-content opacity">
                            <span class="ix-text-bold">{{ schedule.lot.designation }}</span>
                            <div class="d-block ix-text-small">
                                <span v-if="schedule.lot.expected_at"><i class="far fa-calendar"></i> {{ schedule.lot.expected_at }}</span>
                                <span class="ix-text-bold" v-if="schedule.lot.company">- {{ schedule.lot.company }}</span>
                            </div>
                            
                            <span class="d-block ix-text-small">{{ schedule.deal.designation }}</span>
                            <span class="d-block ix-text-small" v-if="schedule.lot.description" v-html="truncate(schedule.lot.description, 40)"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'schedules-single',
        props: ['url', 'dateData', 'previousUrl', 'nextUrl',],
        data() {
            return {
                date: {
                    label: null,
                    date: null,
                    is_today: false
                },

                loading: true,
                schedules: [],
                stations: [],

                selectedStation: null
            };
        },
        computed: {
            filteredSchedules: function () {
                return this.schedules.filter((schedule) => {
                    return this.selectedStation ? schedule.lot.stations.includes(this.selectedStation.id) : true;
                })
            }
        },
        methods: {
            startListening: function(){
                let domain = /:\/\/([^\/]+)/.exec(window.location.href)[1];

                Echo.channel(`${domain}.schedules`)
                    .listen('.schedule-entered-in-day', (e) => {
                        if (e.date == this.date.date) {
                            this.addScheduleAtIndex(e.schedule, e.index);
                        }
                    })
                    .listen('.schedule-removed-from-day', (e) => {
                        if (e.date == this.date.date) {
                            this.removeScheduleAtIndex(e.index);
                        }
                    })
                    .listen('.schedule-moved-in-day', (e) => {
                        if (e.date == this.date.date) {
                            this.moveScheduleFromIndexToIndex(e.schedule, e.oldIndex, e.newIndex);
                        }
                    })
                    .listen('.schedule-stations-lot-updated', (e) => {
                        this.updateStationsInSchedules(e.lot_id, e.stations)
                    });
            },
            stopListening: function(){
                Echo.leaveChannel('schedules');
            },
            addScheduleAtIndex: function(schedule, index) {
                this.schedules.splice(index, 0, schedule);
            },
            removeScheduleAtIndex: function(index) {
                this.schedules.splice(index, 1);
            },
            moveScheduleFromIndexToIndex: function(schedule, fromIndex, toIndex) {
                this.schedules.splice(fromIndex, 1);
                this.schedules.splice(toIndex, 0, schedule);
            },
            updateStationsInSchedules: function(lotId, stations) {
                this.schedules.forEach(schedule => {
                    if (schedule.lot.id == lotId) {
                        schedule.lot.stations = stations
                    }
                });
            },
            getData: async function(){
                this.loading = true;
                fetch(this.url + window.location.search, {
                    ...{
                        method: 'GET'
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then((response) => {
                    this.loading = false;
                    if (response.status == 200) {
                        response.json().then((data) => {
                            this.schedules = data.schedules
                            this.stations = data.stations

                            this.startListening()
                        })
                    }
                }).catch(error => {
                    this.loading = false;
                    console.log(error)
                });
            },
        },
        mounted() {
            $('#date').change(function() {
                // TODO :: Fix "Click sur Aujourdhui"
                $('#dateForm').submit()
            });

            this.date = JSON.parse(this.dateData)
            this.getData()
        }
    }
</script>
